import { Component } from '@angular/core';
import { NavController,NavParams } from 'ionic-angular';
import { AppState } from '../../../../../app/app.global';

@Component({
  templateUrl: 'addressbookinfo.html'
})
export class AddressBookInfo {
	addressbookinfo:any;
	constructor(public navCtrl: NavController,public params: NavParams,public global: AppState) {
		this.addressbookinfo =  params.data;
	}
}



// WEBPACK FOOTER //
// ./src/pages/application/dailyoffice/addressbook/detail/addressbookinfo.ts